// extracted by mini-css-extract-plugin
module.exports = {"nav":"navigation-module--nav--3QLQy","link":"navigation-module--link--3ijCT"};